<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
      </div>
      <div class="avatar-set">
        <div
          v-for="(item, index) in content.options"
          :key="`${index}-${item.label}`"
          :title="item.label"
          @click="() => handleAction(item)"
          class="avatar"
        >
          <CustomIcon :name="item.icon" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
export default {
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        title: String,
        description: String,
        image: String,
        options: Array,
      }),
    },
  },
  components: { CustomIcon },
  methods: {
    handleAction(item) {
      this.action(item);
    },
  },
};
</script>
